import React from 'react';
import { AutoComplete } from 'antd';
import styled from 'styled-components';

const StyledAutoComplete = styled(AutoComplete)``;

export const AutoCompleteInput = (props) => {
  return <StyledAutoComplete menuItemSelectedIcon={null} {...props} />;
};
